import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';
import { ACTION_TYPES } from '../../model/actions';

// Import degli hook corretti
import useSuperpartner from '../../hooks/useSuperpartner';
import useSconti from '../../hooks/useSconti';
import useVoucherSuperpartner from '../../hooks/useVoucherSuperpartner'; // Il NUOVO hook per il magazzino
import useMediaQuery from '../../hooks/useMediaQuery';

// Import dei servizi
import { alertService } from '../../services/AlertService';
import UtilityService from '../../services/UtillityServices/UtilityService';

// Import dei componenti
import CustomTable from '../../components/CustomTable/CustomTable';
import CustomModal from '../../components/CustomModal/CustomModal';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import CreateSuperpartnerForm from '../../components/Forms/CreateSuperpartnerForm/CreateSuperpartnerForm';
import SuperpartnerInfo from '../../components/SuperpartnerInfo/SuperpartnerInfo';
import AssegnaScontoManager from '../../components/AssegnaScontoManager/AssegnaScontoManager';
import GestioneVoucherSuperpartner from '../../components/GestioneVoucherSuperpartner/GestioneVoucherSuperpartner'; // Il NUOVO componente modale
import LiquidazioneAnnualeModal from '../../components/LiquidazioneAnnualeModal/LiquidazioneAnnualeModal';
import useSuperpartnerConfigTable from '../../configTable/useSuperpartnerConfigTable';


const GestioneSuperpartnerPage = () => {
    const { getSuperpartnerByParams, loadingStateSuperpartner, createSuperpartner, deleteSuperpartner, modalStateSuperpartner, setModalStateSuperpartner, updateSuperpartner } = useSuperpartner();
    
    // Dichiarazioni corrette e pulite
    const userLoggedIn = useSelector(state => state.user.userData);
    const { modalStateSconti, setModalStateSconti } = useSconti();
    
    const isWideScreen = useMediaQuery('(min-width: 1200px)');
    const [superpartnerList, setSuperpartnerList] = useState([]);
    const [selectedSuperpartner, setSelectedSuperpartner] = useState(null);
    const [formCreateSuperpartner, setFormCreateSuperpartner] = useState({});
    const [orderBy, setOrderBy] = useState('nome');
    const [orderType, setOrderType] = useState('asc');
    const [selectedPage, setSelectedPage] = useState(1); 
    const [formDataFilter, setFormDataFilter] = useState({});
    const [totalPages, setTotalPages] = useState(1);
    const [showVoucherSPModal, setShowVoucherSPModal] = useState(false); // Stato per la NUOVA modale
    const [showLiquidazioneAnnualeModal, setShowLiquidazioneAnnualeModal] = useState(false);

    const superpartnerConfigTable = useSuperpartnerConfigTable();

    useEffect(() => {
        printAllSuperpartner();
    }, [orderBy, orderType, selectedPage]);
  
    const printAllSuperpartner = async () => {
        let obj = { filtri: { ...formDataFilter }, limite: 10, pagina: selectedPage, ordinamento: `${orderBy} ${orderType}` };
        const fetchList = await getSuperpartnerByParams(obj);
        const countPagination = Math.ceil(fetchList?.count / obj.limite);
        setTotalPages(countPagination);
        setSuperpartnerList(fetchList?.data ?? []);
    };
  
    const onFilteredTable = async () => {
        setSelectedPage(1);
        await printAllSuperpartner();
    };

    const handleCloseModal = () => {
        setModalStateSuperpartner({ showModalCreateSuperpartner: false, showModalInfoSuperpartner: false, showModalDeleteSuperpartner: false, showModalUpdateSuperpartner: false });
        setModalStateSconti({ showModalCreateSconto: false });
        setShowVoucherSPModal(false); // Chiude la nuova modale
        setShowLiquidazioneAnnualeModal(false);
        setSelectedSuperpartner(null);
        setFormCreateSuperpartner({});
    };

    const onCreateSuperpartner = async () => {
        const requiredFields = ["nome", "piva", "email"];
        const missingFields = UtilityService.validationForm(formCreateSuperpartner, requiredFields);
        if (missingFields.length > 0) {
            alertService.warn(`I seguenti campi sono obbligatori: ${missingFields.join(", ")}`);
            return;
        }
        const res = await createSuperpartner(formCreateSuperpartner);
        if(res) { printAllSuperpartner(); handleCloseModal(); }
    };

    const onDeleteSuperpartner = async () => {
        const res = await deleteSuperpartner({id_superpartner: selectedSuperpartner?.id_superpartner});
        if(res) { printAllSuperpartner(); handleCloseModal(); }
    };

    const onUpdateSuperpartner = async () => {
        const res = await updateSuperpartner({ ...formCreateSuperpartner, id_superpartner: selectedSuperpartner?.id_superpartner });
        if(res) { printAllSuperpartner(); handleCloseModal(); }
    };
    
    const openInfoModal = (sp) => { setSelectedSuperpartner(sp); setModalStateSuperpartner(s => ({...s, showModalInfoSuperpartner: true})); };
    const openEditModal = (sp) => { setSelectedSuperpartner(sp); setFormCreateSuperpartner(sp); setModalStateSuperpartner(s => ({...s, showModalUpdateSuperpartner: true})); };
    const openDeleteModal = (sp) => { setSelectedSuperpartner(sp); setModalStateSuperpartner(s => ({...s, showModalDeleteSuperpartner: true})); };
    const openModalCreateSuperpartner = () => { setModalStateSuperpartner(s => ({...s, showModalCreateSuperpartner: true})); };
    
    const openAssegnaScontiModal = (superpartner) => {
        setSelectedSuperpartner(superpartner);
        setModalStateSconti(state => ({ ...state, showModalCreateSconto: true }));
    };

    const openVoucherSPModal = (superpartner) => {
        setSelectedSuperpartner(superpartner);
        setShowVoucherSPModal(true);
    };

    const openLiquidazioneAnnualeModal = (superpartner) => {
        setSelectedSuperpartner(superpartner);
        setShowLiquidazioneAnnualeModal(true);
    };

    const handleOrder = (orderBy, orderType) => { setOrderBy(orderBy); setOrderType(orderType); };
    const handlePageChange = (page) => { setSelectedPage(page); };

    const renderSelectedDeleteSuperpartner = () => (<span className="fs-5">Vuoi eliminare il superpartner "<b>{selectedSuperpartner?.nome}</b>"?</span>);
    
    const actions = [
        { label: ACTION_TYPES.DETAILS, icon: 'bi-info-circle text-dark', type: ACTION_TYPES.CONFIG, onClick: openInfoModal },
        {
            label: "Assegna Sconti", icon: 'bi-percent text-dark', type: ACTION_TYPES.MANAGER,
            onClick: openAssegnaScontiModal
        },
        {
            label: "Magazzino Voucher", icon: 'bi-archive-fill text-primary', type: ACTION_TYPES.MANAGER,
            onClick: openVoucherSPModal
        },
        {
            label: "Liquidazione annuale", icon: 'bi-calendar-check text-info', type: ACTION_TYPES.MANAGER,
            onClick: openLiquidazioneAnnualeModal,
            condition: (row) => row.id_superpartner == 2
        },
        { label: ACTION_TYPES.UPDATE, icon: 'bi-pencil-fill text-warning', type: ACTION_TYPES.CONFIG, onClick: openEditModal },
        { label: ACTION_TYPES.DELETE, icon: 'bi-trash-fill text-danger', type: ACTION_TYPES.CONFIG, onClick: openDeleteModal }
    ];

    return (
        <>
            <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`}>
                <div className='container'>
                    <div className='d-flex justify-content-between custom-card-header'>
                        <div className='d-flex gap-3 custom-card-title my-2'>
                            <div className="custom-icon-container"><i className="bi custom-icon bi-star-fill fs-2"></i></div>
                            <div className='align-self-center'><span className='fs-4 d-block'><i><b>Gestione Superpartner</b></i></span></div>
                        </div>
                        <div className='align-self-center my-2'><button type='button' className='btn btn-primary' onClick={openModalCreateSuperpartner}>Crea Superpartner</button></div>
                    </div>
                    <div className='mt-5'>
                        <CustomFilterTable formDataFilter={formDataFilter} setFormDataFilter={setFormDataFilter} onFilteredTable={onFilteredTable}
                            isLoadingData={loadingStateSuperpartner.isLoadingSuperpartnerByParams}
                            searchNodeType={[ {nodeType: "input", name: "nome", placeholder: "nome"}, {nodeType: "input", name: "piva", placeholder: "partita iva"} ]}
                        />
                    </div>
                    {!loadingStateSuperpartner.isLoadingSuperpartnerByParams ? ( 
                        <>
                            {(!superpartnerList || superpartnerList.length === 0) ? (
                                <div className='mt-5 pt-5 text-center'><p>Non ci sono superpartner da mostrare.</p></div>
                            ) : (
                                <>
                                    <CustomTable data={superpartnerList} actions={actions} columns={superpartnerConfigTable} handleOrder={handleOrder} orderBy={orderBy} orderType={orderType}/>
                                    <div className="d-flex justify-content-end mt-1"><CustomPagination totalPages={totalPages} selectedPage={selectedPage} handlePageChange={handlePageChange}/></div>
                                </>
                            )}
                        </>
                    ) : ( <LoadingTable loadingCol={5} /> )}
                </div>
            </div>
            
            <CustomModal show={modalStateSuperpartner.showModalCreateSuperpartner} onHide={handleCloseModal} headerText="Crea Superpartner" size={"lg"} btnText={"Crea"} body={<CreateSuperpartnerForm formCreateSuperpartner={formCreateSuperpartner} setFormCreateSuperpartner={setFormCreateSuperpartner} showModalCreateSuperpartner={modalStateSuperpartner.showModalCreateSuperpartner}/>} isLoading={loadingStateSuperpartner.isSuperpartnerCreating} onSave={onCreateSuperpartner} onUndoChanges={handleCloseModal} />
            <CustomModal show={modalStateSuperpartner.showModalUpdateSuperpartner} onHide={handleCloseModal} headerText="Modifica Superpartner" size={"lg"} btnText={"Salva"} body={<CreateSuperpartnerForm formCreateSuperpartner={formCreateSuperpartner} setFormCreateSuperpartner={setFormCreateSuperpartner} showModalCreateSuperpartner={modalStateSuperpartner.showModalUpdateSuperpartner}/>} isLoading={loadingStateSuperpartner.isSuperpartnerUpdating} onSave={onUpdateSuperpartner} onUndoChanges={handleCloseModal} />
            <CustomModal show={modalStateSuperpartner.showModalDeleteSuperpartner} onHide={handleCloseModal} headerText="Elimina Superpartner" size={"md"} variant={"danger"} btnText={"Elimina"} body={renderSelectedDeleteSuperpartner()} isLoading={loadingStateSuperpartner.isSuperpartnerDeleting} onSave={onDeleteSuperpartner} onUndoChanges={handleCloseModal} />
            <CustomModal show={modalStateSuperpartner.showModalInfoSuperpartner} onHide={handleCloseModal} headerText="Informazioni Superpartner" size={"lg"} hideSaveBtn={true} body={<SuperpartnerInfo superpartnerData={selectedSuperpartner} />} onUndoChanges={handleCloseModal} />
            
            {selectedSuperpartner && (
                <>
                    <AssegnaScontoManager
                        selectedAgenzia={selectedSuperpartner}
                        modalStateSconti={modalStateSconti}
                        onHide={handleCloseModal}
                    />
                    <GestioneVoucherSuperpartner
                        show={showVoucherSPModal}
                        onHide={handleCloseModal}
                        superpartner={selectedSuperpartner}
                        onUpdate={printAllSuperpartner}
                    />
                    <LiquidazioneAnnualeModal
                        show={showLiquidazioneAnnualeModal}
                        onHide={handleCloseModal}
                        superpartner={selectedSuperpartner}
                    />
                </>
            )}
        </>
    );
}

export default GestioneSuperpartnerPage;